import React from 'react';
import Container from '../layouts/Containerlayout.jsx'
function Nav(props) {
    return (
        <div className='z-[10] bg-transparent fixed w-full top-0 bg-black'>
            <Container className='text-white'>
                <div className='flex items-center max-md:px-8 justify-between p-4 text-white'>
                    <div className='text-2xl font-bold gradient-text cursor-pointer transform transition-all hover:scale-105 text-[30px] text-center 
    bg-white 
    bg-clip-text text-transparent font-bold'>YW</div>
                    <nav>
                        <ul className='flex space-x-12 max-md:space-x-4 max-md:text-[12px] max-md:space-x-2'>
                            <li><a href='#hero' className=''>Home</a></li>
                            <li><a href='#about' className=''>About</a></li>
                            <li><a href='#skills' className=''>Skills</a></li>
                            <li><a href='#projects' className=''>Projects</a></li>
                        </ul>
                    </nav>
                </div>
            </Container>
        </div>
    );
}

export default Nav;